<template>
  <v-app>
    <v-app-bar
      app
      fixed
      color="white"
      style="color:#137967"
    >
      <div class="d-flex align-center" @click="goHome()" style="cursor: pointer">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/logo.png')"
          transition="scale-transition"
          width="40"
        />

        <h2>
          HortusBox
        </h2>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        @click="goShop()"
        text
      >
        <span class="mr-2">Boutique</span>
      </v-btn>
    </v-app-bar>
  
    <v-content>
      <router-view></router-view>
    </v-content>  
  </v-app>
</template>

<script>
export default {
  name: 'HortusBox',

  data: () => ({
    //
  }),
  methods: {
    goHome () {
      if (this.$route.path === '/') {
        return
      }
      this.$router.push('/')
    },
    goShop () {
      if (this.$route.path === '/shop') {
        return
      }
      this.$router.push('/shop')
    }
  }
};
</script>

<style>

</style>